export default __webpack_public_path__ + "static/logo-b173bcd89c5461e81451b52ae6678e0f.svg";